<template>
    <div>
        <Wizard v-if="!loading"></Wizard>
        <b-loading
            v-model="loading"
            :can-cancel="false"
            :is-full-page="true"
        ></b-loading>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'Home',
    data() {
        return {
            loading: true
        }
    },
    created() {
        if (this.form) {
            this.loading = false
        } else {
            this.getInitialForm()
        }
    },
    computed: {
        ...mapGetters('form', {
            form: 'getForm'
        })
    },
    methods: {
        ...mapActions('form', ['getForm']),

        getInitialForm: function () {
            this.getForm()
                .then(() => {
                    this.loading = false
                })
                .catch((error) => {
                    if (error.response.status == 403) {
                        this.loading = false
                        this.$store.dispatch('toast', {
                            type: 'error',
                            title: this.$t('error.application.title_inactive'),
                            message: this.$t('error.application.deactivated')
                        })
                    }
                })
        }
    }
}
</script>
